<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="tag.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            tag: {}
        };
    },

    watch: {
        tag() {
            this.$emit('input', this.tag);
        }
    },

    mounted() {
        this.tag = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.tag[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.tag,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
